import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import './styles/Articles.css';

const Articles = () => {
  const articles = [
    { title: 'Ça se complique', image: '/album/complique/articlecomplique.jpg', alt: 'Affiche de l\'article Ça se complique' },
    { title: 'La diva du sofa', image: '/album/diva/divaarticle.jpg', alt: 'Affiche de l\'article La diva du sofa' },
    { title: '14 juillet à la maison de retraite', image: '/album/retraite/retraitearticle.jpg', alt: 'Affiche de l\'article 14 juillet à la maison de retraite' },
  ];

  const [selectedImage, setSelectedImage] = useState(null);

  const openImage = (image) => {
    setSelectedImage(image);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Articles de Presse | Les Z'ineuvitables - Théâtre à Neuville-en-Ferrain</title>
        <meta name="description" content="Découvrez les derniers articles de presse sur les créations, événements et projets de la troupe de théâtre Les Z'Ineuvitables à Neuville-en-Ferrain." />
        <meta name="keywords" content="articles de presse, théâtre, Neuville-en-Ferrain, troupe amateur, solidarité, création, comédie, amicale laïque, salle Malraux, Les Z'ineuvitables, théâtre, théâtre amateur, événements culturels, spectacles, Neuville" />
        <meta property="og:title" content="Articles de Presse | Les Z'ineuvitables - Théâtre à Neuville-en-Ferrain" />
        <meta property="og:url" content="https://www.zineuvitables.org/articles" />
        <meta property="og:image" content="https://zineuvitables.org/album/retraite/retraitearticle.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="fr_FR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Articles de Presse | Les Z'ineuvitables - Théâtre à Neuville-en-Ferrain" />
        <meta name="twitter:description" content="Découvrez les derniers articles de presse sur les créations, événements et projets de la troupe amateur de théâtre Les Z'ineuvitables à Neuville-en-Ferrain." />
        <meta name="twitter:image" content="https://zineuvitables.org/album/diva/divaarticle.jpg" />
      </Helmet>

      <div className="articles-container">
  <h1><span className="article-icon">📰</span> Articles de presse</h1>
        <div className="articles-grid">
          {articles.map((article, index) => (
            <div
              key={index}
              className="article-card"
              onClick={() => openImage(article.image)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => { if (e.key === 'Enter') openImage(article.image); }}
              aria-label={`Voir l'article ${article.title}`}
            >
              <img
                src={article.image}
                alt={article.alt}
                className="article-thumbnail"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {/* Lightbox pour affichage grand écran */}
        {selectedImage && (
          <div className="lightbox" onClick={closeImage} role="dialog" aria-modal="true" aria-label="Image agrandie">
            <div className="lightbox-content" onClick={e => e.stopPropagation()}>
              <img
                src={selectedImage}
                alt="Article en grand"
                className="lightbox-image"
              />
              <button className="lightbox-close" onClick={closeImage} aria-label="Fermer">
                ✖
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Articles;
